export const BOTS = Object.freeze({
  dagonet: Object.freeze({
    key: 'dagonet',
    name: 'Dagonet',
    profileUrl: 'https://manifold.markets/Dagonet'
  }),
  galahad: Object.freeze({
    key: 'galahad',
    name: 'Galahad',
    profileUrl: 'https://manifold.markets/Galahad'
  })
});

export const BOT_OPTIONS = Object.values(BOTS);

export function botFromHash(hash) {
  const key = String(hash || '').replace(/^#/, '').toLowerCase();
  return BOTS[key]?.key || 'dagonet';
}

export function hashForBot(bot) {
  return bot === 'galahad' ? '#galahad' : '';
}
